import { requestApi } from '@app/api';
import { withUpload } from '@app/api/paths';
import uploadToS3PresignedUrl from '@app/libs/uploadToS3PresignedUrl';

interface AttachmentUploadResult {
  fileId: string;
  token: string;
  previewUrl: string;
}
interface AttachmentUploadResponse {
  fileId: string;
  token: string;
  presignedPostUrlResult: PresignedPostUrlResult;
  presignedGetUrlResult: PresignedGetUrlResult;
}

interface PresignedPostUrlResult {
  url: string;
  fields: Record<string, string>;
}

interface PresignedGetUrlResult {
  url: string;
}

export async function postAttachmentUploadViaPresignedUrl({
  extension,
  file,
}: {
  extension: string;
  file: File;
}): Promise<AttachmentUploadResult> {
  const response = await requestApi<AttachmentUploadResponse>({
    url: withUpload('/attachments/upload-url'),
    method: 'POST',
    credentials: true,
    data: {
      ext: extension,
    },
  }).then((response) => response.data);

  await uploadToS3PresignedUrl({
    file,
    fields: response.presignedPostUrlResult.fields,
    url: response.presignedPostUrlResult.url,
  });

  return {
    fileId: response.fileId,
    token: response.token,
    previewUrl: response.presignedGetUrlResult.url,
  };
}
